export default __webpack_public_path__ + "static/media/statusDeclined.03e021c0.png";